// extracted by mini-css-extract-plugin
module.exports = {"notifications":"_16Ut3W","shine-lines":"_14ec2R"};